var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFilterIcon = function SvgFilterIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.75,
    d: "M10.334 13.253a.64.64 0 0 1-.193.554c-.26.26-.68.26-.94 0l-2.673-2.674a.66.66 0 0 1-.194-.553V7.167L3.141 3.08a.667.667 0 0 1 .113-.933A.7.7 0 0 1 3.668 2H13c.147 0 .287.053.413.147.287.226.34.646.114.933l-3.194 4.087zm-5.306-9.92 2.64 3.374v3.68L9 11.72V6.7l2.64-3.367z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFilterIcon);
export { ForwardRef as ReactComponent };